'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  width: 32px;\n  max-width: 32px;\n  min-width: 32px;\n  margin-right: 10px;\n'], ['\n  display: block;\n  width: 32px;\n  max-width: 32px;\n  min-width: 32px;\n  margin-right: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Avatar = require('../../Avatar/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject);

var StepsNumericIcon = function StepsNumericIcon(_ref) {
  var step = _ref.step,
      current = _ref.current,
      done = _ref.done;
  return _react2.default.createElement(Container, null, done ? _react2.default.createElement(_Button2.default, {
    icon: 'check',
    outline: current !== step && done,
    theme: step > current ? done ? 'black' : 'grey' : 'red'
  }) : _react2.default.createElement(_Avatar2.default, {
    avatar: '' + step,
    outline: step < current,
    theme: step > current ? 'grey' : 'red'
  }));
};

StepsNumericIcon.propTypes = {
  step: _propTypes2.default.number,
  current: _propTypes2.default.number,
  done: _propTypes2.default.bool
};
exports.default = StepsNumericIcon;